// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IjPX","content":"styles_content__qGpp6","row":"styles_row__a8Bp8","footer":"styles_footer__2goZP","phraseLength":"styles_phraseLength__24keD"};